import * as React from "react";
import { DataLayer } from "@grandvisionhq/analytics";
import { appointmentBookingAddToCalendarEvent } from "../../../../v3/data-layer/actions.js";
const useAddToCalendarDlEventDispatcher = ({
  appointmentCondition,
  store,
  type,
  timeSlot,
  isVirtualAppointment
}) => {
  const pushAddToCalendarDlEvent = React.useCallback(() => {
    if (store) {
      const dataLayerEvent = appointmentBookingAddToCalendarEvent({
        condition_of_appointment: appointmentCondition,
        appointment: {
          type_of_appointment: isVirtualAppointment ? "videocall" : "onsite",
          type_of_service: type?.id ?? ""
        },
        storeDetails: { id: store.globalStoreId ?? "", city: store.town, ...store },
        text_of_the_element: "add to calendar",
        time: {
          startTime: timeSlot?.from,
          endTime: timeSlot?.until
        },
        ageGroup: type?.ageGroup ?? "ADULT"
      });
      DataLayer.pushEvent(dataLayerEvent);
    }
  }, [appointmentCondition, store, type, timeSlot, isVirtualAppointment]);
  return React.useMemo(
    () => ({
      pushAddToCalendarDlEvent
    }),
    [pushAddToCalendarDlEvent]
  );
};
export {
  useAddToCalendarDlEventDispatcher
};
//# sourceMappingURL=use-add-to-calendar-dl-event-dispatcher.js.map
